import { useState } from 'react';

const navLinks = [
  { label: 'Introducere', href: '#introducere' },
  { label: 'Concepte de Bază', href: '#concepte' },
  { label: 'Instrumente', href: '#instrumente' },
  { label: 'Strategii', href: '#strategii' },
  { label: 'Managementul Riscului', href: '#risc' },
  { label: 'FAQ', href: '#faq' },
];

const socials = [
  { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
  { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
  { icon: 'ri-facebook-circle-line', label: 'Facebook', href: '#' },
  { icon: 'ri-telegram-line', label: 'Telegram', href: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const form = e.currentTarget;
    const formData = new URLSearchParams();
    formData.append('email', email);
    try {
      const res = await fetch('https://readdy.ai/api/form/d72otekmc4tbhfnc6j40', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
    setTimeout(() => setStatus('idle'), 4000);
  };

  return (
    <footer id="footer" className="pt-20 pb-8 px-6 lg:px-10" style={{ background: '#0f1419' }}>
      <div className="max-w-7xl mx-auto">
        {/* Button 3 — CTA bar at top of footer */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-14 px-8 py-7 rounded-2xl"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,169,110,0.18)' }}
        >
          <div>
            <p className="text-white font-bold text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
              Nu ești sigur? Încearcă mai întâi Demo.
            </p>
            <p className="text-gray-500 text-sm">Exersează fără risc cu fonduri virtuale. 100% gratuit.</p>
          </div>
          <a
            href="https://clicks.affstrack.com/c?c=1197206&l=ja&p=1"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex-shrink-0 flex items-center gap-5 px-14 py-7 rounded-2xl font-semibold text-lg whitespace-nowrap cursor-pointer"
            style={{
              color: '#c9a96e',
              border: '2px solid rgba(201,169,110,0.55)',
              background: 'rgba(201,169,110,0.07)',
              transition: 'transform 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
            }}
            onMouseEnter={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = 'scale(1.04) translateY(-2px)';
              el.style.background = 'rgba(201,169,110,0.15)';
              el.style.borderColor = '#c9a96e';
              el.style.boxShadow = '0 12px 32px rgba(201,169,110,0.18)';
            }}
            onMouseLeave={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = 'scale(1)';
              el.style.background = 'rgba(201,169,110,0.07)';
              el.style.borderColor = 'rgba(201,169,110,0.55)';
              el.style.boxShadow = 'none';
            }}
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-xl" style={{ background: 'rgba(201,169,110,0.15)' }}>
              <i className="ri-vip-crown-line text-xl" style={{ color: '#c9a96e' }} />
            </div>
            Exersează cu Cont Demo (Gratuit)
            <i className="ri-arrow-right-s-line text-xl" />
          </a>
        </div>

        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Col 1 — Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg" style={{ background: '#4ecdc4' }}>
                <i className="ri-line-chart-line text-white text-lg"></i>
              </div>
              <span className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                FX<span style={{ color: '#4ecdc4' }}>Learn</span>
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
              Începe Călătoria Ta în Forex
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Educație gratuită de calitate pentru toți cei care doresc să înțeleagă piața valutară.
            </p>
            {/* Socials */}
            <div className="flex items-center gap-3 flex-wrap">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-gray-400 hover:text-white hover:border-white/40 transition-colors cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Navigation */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Navigare</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleScroll(e, link.href)}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Resources */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Resurse</h4>
            <ul className="space-y-3">
              {[
                { icon: 'ri-book-2-line', label: 'Glosar Forex' },
                { icon: 'ri-calculator-line', label: 'Calculator Pip' },
                { icon: 'ri-bar-chart-2-line', label: 'Grafice Live' },
                { icon: 'ri-calendar-event-line', label: 'Calendar Economic' },
                { icon: 'ri-file-text-line', label: 'Jurnal de Trading' },
              ].map((r, i) => (
                <li key={i}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    <i className={`${r.icon} text-xs`} style={{ color: '#4ecdc4' }}></i>
                    {r.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Newsletter */}
          <div>
            <h4 className="text-white font-bold mb-2 text-sm uppercase tracking-wider">Newsletter</h4>
            <p className="text-gray-400 text-sm mb-5 leading-relaxed">
              Primește actualizări săptămânale despre piața Forex și sfaturi de trading.
            </p>

            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex items-center gap-0"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Email-ul tău..."
                className="flex-1 px-4 py-3 text-sm rounded-l-full bg-white/10 border border-white/15 text-white placeholder-gray-500 focus:outline-none focus:border-teal-400 transition-colors"
              />
              <button
                type="submit"
                className="w-12 h-12 flex items-center justify-center rounded-r-full flex-shrink-0 whitespace-nowrap transition-opacity hover:opacity-90 cursor-pointer"
                style={{ background: '#4ecdc4' }}
                aria-label="Abonează-te"
              >
                <i className="ri-arrow-right-line text-white font-bold"></i>
              </button>
            </form>

            {status === 'success' && (
              <p className="text-teal-400 text-xs mt-2 flex items-center gap-1">
                <i className="ri-checkbox-circle-line"></i>
                Abonare reușită!
              </p>
            )}
            {status === 'error' && (
              <p className="text-red-400 text-xs mt-2 flex items-center gap-1">
                <i className="ri-close-circle-line"></i>
                Eroare. Încearcă din nou.
              </p>
            )}

            {/* Trust badges */}
            <div className="flex items-center gap-4 mt-5">
              {[
                { icon: 'ri-lock-line', label: 'Securizat' },
                { icon: 'ri-mail-check-line', label: 'Fără spam' },
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-1.5 text-gray-500 text-xs">
                  <i className={`${b.icon} text-sm`}></i>
                  {b.label}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px mb-8" style={{ background: 'rgba(255,255,255,0.08)' }}></div>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            © 2025 FXLearn. Toate drepturile rezervate.
          </p>
          <p className="text-gray-600 text-xs text-center max-w-md">
            Tranzacționarea Forex implică risc. Pierde numai ceea ce îți permiți. Nu este sfat financiar.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-gray-500 text-xs hover:text-gray-300 transition-colors" rel="nofollow">
              Termeni
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-gray-500 text-xs hover:text-gray-300 transition-colors" rel="nofollow">
              Confidențialitate
            </a>
          </div>
        </div>

        {/* Watermark */}
        <div
          className="text-center mt-6 text-6xl md:text-8xl font-black select-none pointer-events-none"
          style={{ color: 'rgba(255,255,255,0.025)', fontFamily: 'Playfair Display, serif', letterSpacing: '0.1em' }}
        >
          FOREX TRADING
        </div>
      </div>
    </footer>
  );
}
